import { render } from "./PersonalMinimums.vue?vue&type=template&id=0ea6bf4c"
import script from "./PersonalMinimums.vue?vue&type=script&lang=js"
export * from "./PersonalMinimums.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__